module.exports = __webpack_public_path__ + "static/img/zyc11.4b87c09d.png";